import React from 'react';

const BG = '#F4F8F9';
const BORDER = '#E5ECEC';
const MUTED = '#6B7787';
const TEAL_DARK = '#05292A';

// Layout is inline on purpose: the host's Tailwind build only scans its own
// source, so a class used only by this module can be missing in production.
export const FilterField = ({
  label,
  icon,
  children,
  fluid,
}: {
  label: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  /** Take the full row (mobile) instead of hugging the content (desktop). */
  fluid?: boolean;
}) => (
  <label
    style={{
      display: fluid ? 'flex' : 'inline-flex',
      width: fluid ? '100%' : undefined,
      boxSizing: 'border-box',
      alignItems: 'center',
      gap: 8,
      borderRadius: 12,
      backgroundColor: BG,
      border: `1px solid ${BORDER}`,
      padding: '8px 12px',
      minWidth: 0,
    }}
  >
    <span style={{ color: MUTED, flexShrink: 0, display: 'flex' }}>{icon}</span>
    <span
      style={{
        fontSize: '11px',
        color: MUTED,
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        flexShrink: 0,
      }}
    >
      {label}
    </span>
    {children}
  </label>
);

/** The bare control that sits inside a FilterField: the pill is the border. */
export const filterControlStyle = (fluid?: boolean): React.CSSProperties => ({
  background: 'transparent',
  border: 'none',
  outline: 'none',
  fontFamily: 'inherit',
  fontSize: '13px',
  fontWeight: 500,
  color: TEAL_DARK,
  minWidth: '128px',
  flex: fluid ? 1 : undefined,
  width: fluid ? '100%' : undefined,
});

export const IconCalendar = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="5" width="18" height="16" rx="3" stroke="currentColor" strokeWidth="1.6" />
    <path d="M8 3v4M16 3v4M3 10h18" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);
